import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Search } from 'app/models';

export interface UserTopicDto {
  topicId?: number;
  name?: string;
  query?: string;
  company: boolean;
  userLabelId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class TopicService {
  private api: string;
  private httpOptions: any;

  constructor(private http: HttpClient) {
    this.api = environment.api_url;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public rankedTopicsSearch(
    search: Search,
    page = 0,
    size = 50
  ): Observable<any> {
    return this.http.post(
      `${this.api}/topics/search?page=${page}&size=${size}`,
      search,
      this.httpOptions
    );
  }

  public topicsSearchPreview(search: Search): Observable<any> {
    return this.http.post(
      `${this.api}/topics/search/preview`,
      search,
      this.httpOptions
    );
  }

  public coveragePreviewSearch(search: Search): Observable<any> {
    const url = `${this.api}/search/content/stats`;
    return this.http.post(url, search, this.httpOptions);
  }

  public getTopicFull(id: number): Observable<any> {
    return this.http.get(`${this.api}/topics/${id}`, this.httpOptions);
  }

  public getTopicHistory(id): Observable<any> {
    return this.http.get(`${this.api}/topics/${id}/stats`, this.httpOptions);
  }

  public getTopicsMenu(): Observable<any> {
    return this.http.get(`${this.api}/topics/menu`, this.httpOptions);
  }

  public getTopicsSaved(projectId): Observable<any> {
    return this.http.get(
      `${this.api}/project/v2/${projectId}/topics`,
      this.httpOptions
    );
  }

  // Persists the complete list transactionally as contiguous order values (1..n).
  public updateTopicOrder(
    projectId: number,
    orderedIds: number[]
  ): Observable<any> {
    return this.http.put(
      `${this.api}/project/v2/${projectId}/topics/order`,
      orderedIds,
      this.httpOptions
    );
  }

  public getTopicBasic(topicId): Observable<any> {
    return this.http.get(
      `${this.api}/topics/${topicId}/basic`,
      this.httpOptions
    );
  }

  public getUserTopic(projectId: number, topicId: number): Observable<any> {
    return this.http.get(
      `${this.api}/project/v2/${projectId}/topics/${topicId}`,
      this.httpOptions
    );
  }

  public save(topic, projectId: number): Observable<any> {
    return this.http.post(
      `${this.api}/project/v2/${projectId}/topics`,
      topic,
      this.httpOptions
    );
  }

  public update(
    topic,
    projectId: number,
    userTopicId: number
  ): Observable<any> {
    return this.http.put(
      `${this.api}/project/v2/${projectId}/topics/${userTopicId}`,
      topic,
      this.httpOptions
    );
  }

  public delete(projectId: number, userTopicId: number): Observable<any> {
    return this.http.delete(
      `${this.api}/project/v2/${projectId}/topics/${userTopicId}`,
      this.httpOptions
    );
  }

  // TODO What is this?  I don't think it's used anymore
  public feedTopic(topicId, sort, p, s): Observable<any> {
    return this.http.post(
      `${this.api}/content/userTopic/${topicId}/${sort}?page=${p}&size=${s}`,
      '{}',
      this.httpOptions
    );
  }
}
